export const cx = (...classes) => classes.filter(Boolean).join(" ");
export const serif = "font-['Libre_Caslon_Display',Georgia,serif]";
export const shell = "mx-auto w-[min(1320px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]";

export const ArrowUpRight = ({ className = "h-4 w-4" }) => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className={className}>
        <path d="M7 17 17 7M9 7h8v8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const DownloadIcon = ({ className = "h-5 w-5" }) => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className={className}>
        <path d="M12 4v10m0 0 4-4m-4 4-4-4M5 18h14" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const CalendarIcon = ({ className = "h-5 w-5" }) => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className={className}>
        <rect x="4" y="6" width="16" height="14" rx="2" stroke="currentColor" strokeWidth="1.7" />
        <path d="M8 3v5M16 3v5M4 10h16" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    </svg>
);

export const BookIcon = ({ className = "h-5 w-5" }) => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className={className}>
        <path d="M5 4h10a3 3 0 0 1 3 3v13H8a3 3 0 0 1-3-3V4Z" stroke="currentColor" strokeWidth="1.7" />
        <path d="M8 20V7a3 3 0 0 0-3-3M9 9h6M9 13h6" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    </svg>
);

export const UsersIcon = ({ className = "h-5 w-5" }) => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className={className}>
        <circle cx="9" cy="8" r="3" stroke="currentColor" strokeWidth="1.7" />
        <circle cx="17" cy="10" r="2.2" stroke="currentColor" strokeWidth="1.7" />
        <path d="M3.5 19c.4-3.2 2.5-5 5.5-5s5.1 1.8 5.5 5M14 15.2c2.8-.5 5 .7 5.8 3.8" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    </svg>
);

export const BriefcaseIcon = ({ className = "h-5 w-5" }) => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className={className}>
        <path d="M8 7V5.8A1.8 1.8 0 0 1 9.8 4h4.4A1.8 1.8 0 0 1 16 5.8V7M4 8h16v11H4V8Z" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
        <path d="M4 12h16M10 12v2h4v-2" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    </svg>
);

export const SectionEyebrow = ({ children, dark = false }) => (
    <div className={cx("flex items-center gap-3 text-sm font-bold uppercase tracking-[0.16em]", dark ? "text-[#D5AD57]" : "text-[#8B1E3F]")}>
        <span className="h-px w-10 bg-current" />
        <span>{children}</span>
    </div>
);

export const SearchIcon = ({ className = "h-5 w-5" }) => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className={className}>
        <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="1.7" />
        <path d="m16 16 4 4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    </svg>
);

export const Eyebrow = ({ children, dark = false }) => {
    return <div className={`flex items-center gap-3 text-sm font-extrabold uppercase tracking-[0.14em] ${dark ? "text-[#D5AD57]" : "text-[#8B1E3F]"}`}><span className="h-px w-10 bg-current" />{children}</div>;
}

export const Title = ({ children, dark = false, as: Tag = "h2", className = "" }) => {
    return <Tag className={`${serif} mt-5 text-[clamp(38px,4.7vw,66px)] font-normal leading-[1.06] tracking-[-0.04em] ${dark ? "text-white" : "text-[#071A2F]"} ${className}`}>{children}</Tag>;
}

export const SubTitle = ({ children, dark = false, as: Tag = "h6", className = "" }) => {
    return <Tag className={`mt-5 text-base leading-8 text-[#526071] ${dark ? "text-white" : "text-[#071A2F]"} ${className}`}>{children}</Tag>;
}

export const Arrow = () => {
    return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-5 w-5" aria-hidden="true"><path strokeLinecap="round" strokeLinejoin="round" d="M5 12h14m-5-5 5 5-5 5" /></svg>;
}

export const Label = ({ children, light = false }) => {
    return <span className={`text-sm font-extrabold uppercase tracking-[.16em] ${light ? "text-[#D5AD57]" : "text-[#8B1E3F]"}`}>{children}</span>;
}

export const CTA = ({
    title = "Begin your application",
    bg = "burgundy",
}) => {
    const bgStyles = {
        gold: "bg-[#D5AD57] text-[#071A2F]",
        navy: "bg-[#071A2F] text-white",
        white: "bg-white text-[#071A2F]",
        burgundy: "bg-burgundy text-white",
    };

    return (
        <a
            href="/apply"
            className={`inline-flex min-h-14 items-center gap-8 px-7 mt-5 text-sm font-bold transition hover:-translate-y-1 ${bgStyles[bg] || bgStyles.burgundy
                }`}
        >
            {title}
            <Arrow />
        </a>
    );
};